import ReportSetup from './container/index';

export default ReportSetup;



// WEBPACK FOOTER //
// ./src/views/ReportSetup/index.js